import React, { PureComponent } from 'react'
import { func, string, shape } from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Popover from '@active/react-ui/Popover'
import Input from '@active/react-ui/Input'
import { Locale, withI18n } from '@active/react-utils/i18n'
import './PaymentAlias.scss'

class PaymentAlias extends PureComponent {
  static propTypes = {
    getPaymentAliasCallBack: func.isRequired,
    defaultValue: shape({
      displayName: string,
    }),
    i18n: func.isRequired,
  }

  static defaultProps = {
    defaultValue: {
      displayName: '',
    },
  }

  handleChange = ({ target: { value } }) => {
    const { getPaymentAliasCallBack } = this.props
    getPaymentAliasCallBack(value)
  }

  render() {
    const { defaultValue, i18n } = this.props
    return (
      <div className="checkout-payments checkout__paymentAlias">
        <h2 className="checkout-payments__title">
          <Locale id="passport.lib.components.payment.alias.title" />
          <Popover
            content={<Locale id="passport.lib.components.payment.alias.tip" />}
            placement="auto"
            theme="dark"
          >
            <i role="region" tabIndex={0} aria-label={i18n('passport.lib.components.payment.alias.tip')} className="ic-question-r question-icon" />
          </Popover>
        </h2>
        <Form initialValues={defaultValue} horizontal>
          <FormGroup name="displayName">
            <FormLabel><Locale id="passport.lib.components.payment.alias.label" /></FormLabel>
            <FormField as={Input} maxLength={255} onChange={this.handleChange} />
          </FormGroup>
        </Form>
      </div>
    )
  }
}

export default withI18n(PaymentAlias)
